import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useRef, useState } from "react";
import DetailJobSeeker from "@Molecule/_jobSeekers/DetailJobSeeker";
import HomeFooter from "@Organism/Home/Business/HomeFooter";
import useQuery from "@Hooks/useQuery";
import Toast from "@Atom/Toast";
import ModalWrapper from "@Atom/ModalWrapper";
import ShareLinkModal from "./ShareLinkModal";
import { handleSubmit } from "@Helpers/getLinkJobPosting";
import useWindowSize from "@Hooks/useWindowSize";
import JobPostingLinkModal from "@Molecule/_modal/JobPostingLinkModal";
import moment from "moment";
import Images from "@Theme/Images";
import { fileBaseUrl } from "@Config/api";
import JobSeekersCard from "@Molecule/JobSeekersCard";
import {
  createCandidateBookmark,
  deleteCandidateBookmark,
} from "@Services/home";
import ApplyJobModal from "./ApplyJobModal";
import OTPConfirmationModal from "@Molecule/_modal/OTPConfirmationModal";
import AddLinkVideoModal from "@Molecule/_modal/AddLinkVideoModal";
import ModalOptionalDocument from "@Organism/Additional/JobApplicationForm/ModalOptionalDocument";

export default function PreviewJobSeeker({
  data,
  getListDropdown,
  getListLocation,
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const query = useQuery();

  const { width } = useWindowSize();

  const targetElement = useRef();
  const scrollingTop = (event) => {
    const elmnt = targetElement;
    elmnt.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start",
    });
  };

  useEffect(() => {
    scrollingTop();
  }, []);

  const [trigger, setTrigger] = useState(query?.get("tr") || "");
  const [success, setSuccess] = useState("");
  const [hash, setHash] = useState(query?.get("h") || "");
  const [verificationState, setVerificationState] = useState(
    query?.get("v") || ""
  );
  const [error, setError] = useState("");
  const [errorLinkJobPost, setErrorLinkJobPost] = useState(null);

  const [isLoadingCopyLink, setIsLodingCopyLink] = useState(null);
  const [isLoadingCopyLinkFixed, setIsLodingCopyLinkFixed] = useState(null);
  const [showModalLink, setShowModalLink] = useState("");
  const [modalLinkVideo, setModalLinkVideo] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);

  const [modalApplyExternal, setModalApplyExternal] = useState(
    query?.get("m") === "true" ? true : false
  );

  const [phoneNumber, setPhoneNumber] = useState(query?.get("p") || "");

  const defaultValuesStepOne = JSON.parse(
    sessionStorage.getItem("valueStepOneJobApply")
  );
  const [valueStepOne, setValueStepOne] = useState({
    personId: defaultValuesStepOne?.personId || "",
    phoneNumber: defaultValuesStepOne?.phoneNumber || "",
    isVerificationPhone: defaultValuesStepOne?.isVerificationPhone || false,
    isValidated: defaultValuesStepOne?.isValidated || false,
    name: defaultValuesStepOne?.name || "",
    email: defaultValuesStepOne?.email || "",
    dateOfBirth: defaultValuesStepOne?.dateOfBirth || "",
    gender: defaultValuesStepOne?.gender || "",
    domicile: defaultValuesStepOne?.domicile || "",
    address: defaultValuesStepOne?.address || "",
    lastEducation: defaultValuesStepOne?.lastEducation || "",
    videoLink: defaultValuesStepOne?.videoLink || "",
    experiences: defaultValuesStepOne?.experiences || [],
    skills: defaultValuesStepOne?.skills || [],
    isShowInput: defaultValuesStepOne?.isShowInput || false,
    questions: defaultValuesStepOne?.questions || [],
  });

  const [valueCV, setValueCV] = useState(null);
  const [valueOptional, setValueOptional] = useState([]);
  const [valueOptionaTemp, setValueOptionalTemp] = useState(null);
  const [photoSelfie, setPhotoSelfie] = useState(null);

  useEffect(() => {
    sessionStorage?.setItem(
      "valueStepOneJobApply",
      JSON.stringify(valueStepOne)
    );
  }, [valueStepOne]);

  useEffect(() => {
    navigate(
      `${pathname}?tr=${trigger || ""}&h=${hash || ""}&v=${
        verificationState || ""
      }&m=${modalApplyExternal || false}&p=${phoneNumber || ""}`,
      {
        replace: true,
      }
    );
  }, [
    navigate,
    pathname,
    trigger,
    hash,
    verificationState,
    modalApplyExternal,
    phoneNumber,
  ]);

  useEffect(() => {
    setTimeout(() => {
      if (success || error || errorLinkJobPost) {
        setSuccess("");
        setError("");
        setErrorLinkJobPost(null);
      }
    }, 2000);
  }, [success, error, errorLinkJobPost]);

  useEffect(() => {
    if (
      showShareModal ||
      showModalLink ||
      modalApplyExternal ||
      modalLinkVideo
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
  }, [showShareModal, showModalLink, modalApplyExternal, modalLinkVideo]);

  const handleForm = (el, type, fixed = false) => {
    const syntheticEvent = new Event("submit", {
      bubbles: true,
      cancelable: true,
    });

    if (type !== "External") {
      if (el?.placement?.length > 1) {
        setShowModalLink({
          isShow: true,
          name: "Normal",
          data: {
            ...el,
          },
        });
      } else {
        handleSubmit(
          syntheticEvent,
          el?.placement[0]?.city,
          el?._id,
          fixed ? setIsLodingCopyLinkFixed : setIsLodingCopyLink,
          setErrorLinkJobPost,
          width,
          false
        );
      }
    } else {
      setModalApplyExternal(true);
    }
  };

  useEffect(() => {
    if (modalApplyExternal) {
      if (localStorage?.getItem("accessTokenUserLanding")) {
        setValueStepOne((prev) => ({
          ...prev,
          personId: localStorage?.getItem("personIdUserLanding") || "",
          phoneNumber: localStorage?.getItem("phoneNumberUserLanding") || "",
          isVerificationPhone: true,
          isValidated: true,
          name: localStorage?.getItem("nameUserLanding") || "",
          email: localStorage?.getItem("emailUserLanding") || "",
          isShowInput: true,
          questions:
            data?.response?.data?.questions?.length > 0
              ? data?.response?.data?.questions?.map((el) => {
                  return {
                    ...el,
                    responseCandidate: "",
                  };
                })
              : [],
        }));
      } else {
        setValueStepOne((prev) => ({
          ...prev,
          questions:
            data?.response?.data?.questions?.length > 0
              ? data?.response?.data?.questions?.map((el) => {
                  return {
                    ...el,
                    responseCandidate: "",
                  };
                })
              : [],
        }));
      }
    }
  }, [modalApplyExternal, data]);

  const dataJobPost = useMemo(() => {
    return data?.response?.jobPosts?.map((l) => ({
      id: l?._id,
      name: l?.title,
      experience: l?.experience,
      workType: l?.workType,
      contractType: l?.contractType,
      workMethod: l?.workMethod,
      client: l?.clientName,
      location: l?.placement,
      salary: l?.salary,
      createdAt: moment(l?.createdAt).startOf("day").fromNow(),
      status: l?.status,
      isRevision: "",
      img: l?.iconUri ? fileBaseUrl + l?.iconUri : Images.PERAMATA_LOGO_CICRLE,
      isShowButton: "",
      isApply: l?.isApply,
      isArchived: l?.isBookmarked,
      _id: l?._id, // for the <JobPostingLinkModal /> component
    }));
  }, [data]);

  const [isLoading, setIsLoading] = useState(false);

  const updateBookmark = async (jobPostID, action) => {
    console.log("test");
    try {
      setIsLoading(true);
      if (action === true) {
        await deleteCandidateBookmark(jobPostID);
      } else {
        await createCandidateBookmark(jobPostID);
      }

      setIsLoading(false);
      setError("");
      setSuccess(
        action === true
          ? "Loker berhasil tersimpan"
          : "Loker sudah tidak tersimpan lagi"
      );
      setTrigger(Math.random());
    } catch (error) {
      console.log(error);
      setError(error.response?.data?.error);
      setIsLoading(false);
      setSuccess("");
    }
  };

  return (
    <div className={Styles.container}>
      <div className={Styles.autoScroll} ref={targetElement} />
      {data?.response?.data?.status === "Unpublish" && (
        <div className={Styles.informationStatusFixed}>
          <div className={Styles.informationStatus}>
            <div>
              <div className={Styles.crumbsBox}>
                <Icon icon={"information-solid"} size={20} color={"#FF3E13"} />
                <span>
                  <span>Loker Ditutup</span> : Lowongan kerja ini sudah tidak
                  menerima lamaran lagi
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={Styles.content}>
        <div className={Styles.header}>
          <div>
            <div className={Styles.crumbsBox}>
              <span
                className={Styles.blue}
                onClick={() => {
                  navigate(`/job-seeker`);
                }}
              >
                Daftar loker
              </span>
              <div className={Styles.iconArrow}>
                <Icon icon={"arrow-right"} size={20} color={"#0A0A0A"} />
              </div>

              <span className={Styles.list}>
                {data?.response?.data?.title || "-"}
              </span>
            </div>
          </div>
        </div>

        <div className={Styles.jobsWrapper}>
          <div className={Styles.wrappers}>
            <div>
              <div className={Styles.leftContent}>
                <DetailJobSeeker
                  data={data?.response?.data}
                  setTrigger={setTrigger}
                  loading={+query?.get("tr") !== +trigger}
                  setSuccess={setSuccess}
                  setError={setError}
                  setShowShareModal={setShowShareModal}
                  handleApply={() =>
                    handleForm(
                      data?.response?.data,
                      data?.response?.data?.workType
                    )
                  }
                  isLoadingCopyLink={isLoadingCopyLink}
                  isHide={width <= 820}
                />
              </div>
              <div className={Styles.rightContent}>
                <span>Loker Lain Untukmu</span>
                {dataJobPost?.length > 0 ? (
                  <div className={Styles.cards}>
                    {dataJobPost?.map((el, idx) => {
                      return (
                        <JobSeekersCard
                          key={idx}
                          data={el}
                          setShowDetail={() => {
                            navigate(`/job-seeker/${el?.id}`);
                          }}
                          loading={+query?.get("tr") !== +trigger || isLoading}
                          onClickArchiveIcon={() => {
                            if (
                              !localStorage?.getItem("accessTokenUserLanding")
                            ) {
                              navigate("/user/login");
                            } else {
                              updateBookmark(el?.id, el?.isArchived);
                            }
                          }}
                        />
                      );
                    })}
                  </div>
                ) : (
                  <div className={Styles.emptyBox}>
                    <div>
                      <img src={Images.FILE_SEARCHING} alt="" />
                    </div>
                    <span>Data Loker Tidak Ditemukan</span>
                  </div>
                )}

                <div className={Styles.other}>
                  <span
                    onClick={() => {
                      navigate(`/job-seeker`);
                    }}
                  >
                    Temukan Loker Lainnya
                  </span>
                </div>
              </div>

              {width <= 820 && (
                <div className={Styles.warningBox}>
                  <div className={Styles.star}>
                    <Icon icon={"star"} color={"#96AB12"} size={24} />
                  </div>

                  <div className={Styles.descWarning}>
                    <span>Tips Menjaga Diri</span>
                    <span>
                      Perusahaan dan lowongan pekerjaan di Kerja365 tidak akan
                      meminta data pribadi, informasi rekening, atau pembayaran
                      dalam proses lamaran. Waspadalah terhadap lowongan yang
                      menggunakan Google Form atau grup Telegram tanpa
                      verifikasi yang jelas.
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={Styles.applyJobFixed}>
        <div className={Styles.applyJob}>
          <div>
            <div className={Styles.left}>
              <span>{data?.response?.data?.title || "-"}</span>
              <div>
                <Icon icon={"buildings-preview"} size={16} color={"#91BDF1"} />
                <span>{data?.response?.data?.clientName || "-"}</span>
              </div>
            </div>

            <div className={Styles.right}>
              <button
                disabled={
                  data?.response?.data?.status === "Unpublish" ||
                  isLoadingCopyLinkFixed ||
                  data?.response?.data?.isApplied === true
                }
                onClick={() =>
                  handleForm(
                    data?.response?.data,
                    data?.response?.data?.workType,
                    true
                  )
                }
              >
                {isLoadingCopyLinkFixed ? "Loading..." : "Lamar Sekarang"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Toast
        isSent={success || error || errorLinkJobPost}
        label={success || error || errorLinkJobPost?.error}
        bg={error || errorLinkJobPost ? "red" : ""}
        icon={error || errorLinkJobPost ? "cross-circle" : ""}
      />

      {showShareModal && (
        <ModalWrapper
          isLandingPage
          show={showShareModal}
          handleClose={() => {}}
        >
          <ShareLinkModal
            handleClose={() => setShowShareModal(false)}
            data={data?.response?.data}
            setSuccess={setSuccess}
          />
        </ModalWrapper>
      )}

      {modalApplyExternal && (
        <ModalWrapper
          show={modalApplyExternal}
          handleClose={() => {}}
          isLandingPage
        >
          <ApplyJobModal
            setTigger={setTrigger}
            setSuccess={setSuccess}
            photoSelfie={photoSelfie}
            setPhotoSelfie={setPhotoSelfie}
            setValueOptionalTemp={setValueOptionalTemp}
            valueStepOne={valueStepOne}
            setValueStepOne={setValueStepOne}
            valueCV={valueCV}
            setValueCV={setValueCV}
            valueOptional={valueOptional}
            setValueOptional={setValueOptional}
            handleClose={() => {
              setPhotoSelfie(null);
              setValueOptionalTemp(null);
              setModalApplyExternal(false);
              setValueCV(null);
              setValueOptional([]);
              setValueStepOne((prev) => ({
                ...prev,
                personId: "",
                phoneNumber: "",
                isVerificationPhone: false,
                isValidated: false,
                name: "",
                email: "",
                dateOfBirth: "",
                gender: "",
                domicile: "",
                address: "",
                lastEducation: "",
                videoLink: "",
                experiences: [],
                skills: [],
                isShowInput: false,
                questions: [],
              }));
            }}
            data={data?.response?.data}
            modalApplyExternal={modalApplyExternal}
            setPhoneNumber={setPhoneNumber}
            phoneNumber={phoneNumber}
            setVerificationState={setVerificationState}
            verificationState={verificationState}
            setHash={setHash}
            hash={hash}
            getListDropdown={getListDropdown}
            getListLocation={getListLocation}
            setModalLinkVideo={setModalLinkVideo}
          />
        </ModalWrapper>
      )}

      {hash && verificationState && (
        <ModalWrapper
          show={hash && verificationState}
          handleClose={() => {}}
          isLandingPage
        >
          <OTPConfirmationModal
            handleSubmit={() => {
              setValueStepOne((prev) => ({
                ...prev,
                isShowInput: true,
                isVerificationPhone: true,
              }));
              setVerificationState("");
              setHash("");
              setPhoneNumber("");
            }}
            data={{
              phoneNumber: phoneNumber,
            }}
          />
        </ModalWrapper>
      )}

      {modalLinkVideo && (
        <ModalWrapper
          show={modalLinkVideo}
          handleClose={() => {}}
          isLandingPage
        >
          <AddLinkVideoModal
            handleClose={() => setModalLinkVideo(false)}
            linkUrl={valueStepOne?.videoLink || ""}
            handleSubmit={setValueStepOne}
            isApply
          />
        </ModalWrapper>
      )}

      {valueOptionaTemp && (
        <ModalWrapper
          show={valueOptionaTemp}
          handleClose={() => {}}
          isLandingPage
        >
          <ModalOptionalDocument
            handleClose={() => setValueOptionalTemp(null)}
            syncData={getListDropdown}
            files={valueOptionaTemp}
            setValue={setValueOptional}
            value={valueOptional}
          />
        </ModalWrapper>
      )}

      {showModalLink && (
        <ModalWrapper
          show={showModalLink}
          handleClose={() => setShowModalLink(null)}
          isLandingPage
        >
          <JobPostingLinkModal
            data={showModalLink}
            handleClose={() => setShowModalLink(null)}
          />
        </ModalWrapper>
      )}

      <HomeFooter />
    </div>
  );
}
